import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { NotificationProvider, Notification, UserProvider } from "alpha-ui";
import { LocaleProvider } from "./context/locale";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import store from "./redux/store";
import { Provider } from "react-redux";
const root = ReactDOM.createRoot(document.getElementById("experiment_adda"));
root.render(
  <BrowserRouter basename="/experiment-adda">
    <Provider store={store}>
      <NotificationProvider>
        <LocaleProvider>
          <UserProvider>
            <App />
            <Notification />

          </UserProvider>
        </LocaleProvider>
      </NotificationProvider>
    </Provider>
  </BrowserRouter>
);
